import { format } from "date-fns";

export const formatNextAppointment = (nextAppointmentDate) => {
  if (!nextAppointmentDate) {
    return {
      time: "No appointments",
      fullDate: null,
    };
  }

  const appointmentDate = new Date(nextAppointmentDate);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  const appointmentDay = new Date(
    appointmentDate.getFullYear(),
    appointmentDate.getMonth(),
    appointmentDate.getDate()
  );

  const timeFormat = format(appointmentDate, "h:mm a");

  const fullDateFormat = format(appointmentDate, "MMMM do");

  let dayLabel;
  const diffDays = Math.floor((appointmentDay - today) / (1000 * 60 * 60 * 24));

  const currentWeekEnd = new Date(today);
  currentWeekEnd.setDate(today.getDate() + (6 - today.getDay()));
  const isInCurrentWeek = appointmentDay <= currentWeekEnd;
  const isInNextWeek = appointmentDay > currentWeekEnd && appointmentDay <= new Date(currentWeekEnd.getTime() + 7 * 24 * 60 * 60 * 1000);

  if (diffDays === 0) {
    dayLabel = "Today";
  } else if (diffDays === 1) {
    dayLabel = "Tomorrow";
  } else if (diffDays >= 2 && diffDays <= 6 && isInCurrentWeek) {
    dayLabel = format(appointmentDate, "EEEE");
  } else if (isInNextWeek) {
    dayLabel = `Next ${format(appointmentDate, "EEEE")}`;
  } else {
    dayLabel = format(appointmentDate, "EEEE");
  }

  return {
    time: `${dayLabel} ${timeFormat}`,
    fullDate: fullDateFormat,
  };
};

export const getStatusColor = (status) => {
  switch (status) {
    case "Intake":
      return "primary";
    case "Onboarding":
      return "warning";
    case "Assessment":
      return "info";
    case "Therapy":
      return "success";
    case "Deactivated":
      return "error";
    default:
      return "default";
  }
};

export const sortFilterItems = (items) => {
  return [...items].sort((a, b) => a.display_name.localeCompare(b.display_name));
};
